import React, { useRef, useState } from 'react';
import { TRUSTPILOT_REVIEW_URL } from '../../../../AppConstants';
import { useCookiePreferences } from '../../../../utils/cookiePreferences';
import { useTrustpilotWidget } from '../../../../utils/hooks';

const FRAME_WIDTH_PX = 220;
const CLIP_INSET_PX = 1.5;
const CLIP_HEIGHT_PX = 35;

// Mirrors the Review Collector's own CSS at a 220px-wide frame (its narrowest
// single-line layout): 1px border, 6px side padding, 14px "Review us on" text,
// 4px gap and an 80px logo. Knowing the button width lets us left-align it and
// clip Trustpilot's outline, since we can't style inside the cross-origin iframe
// and the embed has no alignment setting.
// If Trustpilot changes the template, re-check by removing
// `sbf-trustbox--clipped` in dev tools: the button should be centred in the
// 220px frame, and with the class back its outline should sit just outside the
// clipped box on every side. Update the numbers above if it doesn't.
function getTrustBoxLayout() {
  const context = document.createElement('canvas').getContext?.('2d');
  if (!context) {
    return null;
  }
  context.font = '500 14px "Helvetica Neue", Helvetica, Arial, sans-serif';
  const buttonWidth =
    2 + 12 + context.measureText('Review us on').width + 4 + 80;

  return {
    offset: (FRAME_WIDTH_PX - buttonWidth) / 2 + CLIP_INSET_PX,
    clipWidth: buttonWidth - CLIP_INSET_PX * 2,
  };
}

function FooterTrustBox() {
  const widgetRef = useRef(null);
  const { hasConsent } = useCookiePreferences();
  const [measuredLayout] = useState(getTrustBoxLayout);
  useTrustpilotWidget(widgetRef, hasConsent);

  const layout = hasConsent ? measuredLayout : null;
  const clipStyle = layout
    ? {
        width: layout.clipWidth,
        height: CLIP_HEIGHT_PX,
        '--sbf-trustbox-offset': `${layout.offset}px`,
      }
    : undefined;

  return (
    <div
      className={`sbf-trustbox bg-white${
        layout ? ' sbf-trustbox--clipped' : ''
      }`}
      style={clipStyle}
    >
      <div
        ref={widgetRef}
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='56278e9abfbbba0bdcd568bc'
        data-businessunit-id='61657394fa7737001e35bc8a'
        data-style-height='52px'
        data-style-width={`${FRAME_WIDTH_PX}px`}
        data-token='80420e67-21ac-4f10-b10f-8241d07687e3'
      >
        <a
          href={TRUSTPILOT_REVIEW_URL}
          target='_blank'
          rel='noopener noreferrer'
          className='sbf-trustbox__fallback fs-14 gSemiBold grey-900'
        >
          Review us on Trustpilot
        </a>
      </div>
    </div>
  );
}

export default FooterTrustBox;
